"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drag_arrows = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var drag_arrows = function drag_arrows(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'drag-arrows-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.97503 2.46434C9.26665 2.17855 9.7333 2.17855 10.0249 2.46434L12.6201 5.00755C12.9159 5.29746 12.9207 5.77231 12.6308 6.06815C12.3409 6.36399 11.866 6.36879 11.5702 6.07888L10.25 4.78508V9.75003L15.2149 9.75003L13.9211 8.4298C13.6312 8.13396 13.636 7.65911 13.9318 7.3692C14.2277 7.07928 14.7025 7.08408 14.9925 7.37992L17.5357 9.97509C17.8214 10.2667 17.8214 10.7333 17.5357 11.025L14.9925 13.6201C14.7025 13.916 14.2277 13.9208 13.9318 13.6309C13.636 13.3409 13.6312 12.8661 13.9211 12.5702L15.2149 11.25L10.25 11.25V16.2149L11.5702 14.9211C11.866 14.6312 12.3409 14.636 12.6308 14.9318C12.9207 15.2277 12.9159 15.7025 12.6201 15.9925L10.0249 18.5357C9.7333 18.8214 9.26665 18.8214 8.97503 18.5357L6.37987 15.9925C6.08403 15.7025 6.07923 15.2277 6.36914 14.9318C6.65906 14.636 7.13391 14.6312 7.42975 14.9211L8.74997 16.2149L8.74997 11.25H3.78508L5.07888 12.5702C5.36879 12.8661 5.36399 13.3409 5.06815 13.6309C4.77231 13.9208 4.29746 13.916 4.00755 13.6201L1.46434 11.025C1.17855 10.7333 1.17855 10.2667 1.46434 9.97508L4.00755 7.37992C4.29746 7.08408 4.77231 7.07928 5.06815 7.3692C5.36399 7.65911 5.36879 8.13396 5.07888 8.4298L3.78508 9.75002L8.74997 9.75002V4.78508L7.42975 6.07888C7.13391 6.36879 6.65906 6.36399 6.36914 6.06815C6.07923 5.77231 6.08403 5.29746 6.37987 5.00755L8.97503 2.46434Z',
    fill: '#4B5563'
  }));
};

exports.drag_arrows = drag_arrows;